
<template>
  <div class="app-container ">
    <div class="card" v-for="(item, index) in $parent.appList" :key="index" v-if="item.children.length">
      <header>{{ item.name }}</header>
      <van-divider />
      <van-grid :border="false" :column-num="4">
        <van-grid-item v-for="(item, index) in item.children" :key="index">
          <div @click="clickApp(item)">
            <img :src="$parent.baseUrl + item.customIcon" />
            <span>{{ item.name }}</span>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
  </div>
</template>

<script>
const { jumpURL } = projectConfig;
import { logUserClickApi } from "./api";
export default {
  name: "App",
  methods: {
    async clickApp(item) {
      const { id, sourceType, url } = item;
      await logUserClickApi({
        idOperate: id,
        type: 2,
      });
      setTimeout(() => {
        window.open(sourceType === 1 ? jumpURL + url : url);
      }, 300);
      // window.location.href(sourceType === 1 ? jumpURL + url : url)
      // window.open(sourceType === 1 ? jumpURL + url : url)
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;

  .card {
    width: 100%;

    header {
      color: $contentColor;
      font-size: 15px;
      font-weight: bold;
    }

    .van-grid {
      .van-grid-item {
        div {
          display: inline-block;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
        }

        img {
          width: 10vw;
          margin-bottom: 1vh;
        }

        span {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
